export const getSessionUrl = () => {
  try {
    return window?.FS?.getCurrentSessionURL?.();
  } catch (error) {
    console.error('Error getting FullStory session URL:', error);
    return null;
  }
};
